module.exports = __webpack_public_path__ + "static/media/about_us.67ae0c71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/about_us.jpg
// module id = 92
// module chunks = 0